import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Ad from 'models/business/Ad';
import TextInput from 'components/Common/TextInput';
import EmptyBar from 'components/Common/EmptyBar';
import ErrorIconPopover from 'components/Common/ErrorIconPopover';
import ClickableDiv from 'components/Common/ClickableDiv';
import InputErrorMessage from 'components/Common/InputErrorMessage';
import InputWrapper from 'components/Common/InputWrapper';

import classNames from 'classnames';

import Styles from './index.module.css';

export default function AdCardSetting({
  ad,
  onChangeAd,
  disabled,
  active,
  onSetActive,
  handleValidFromAdSettings,
}) {
  const [error, setError] = useState(ad.dayBudget < 500);

  const handleChangeField = (e, field) => {
    const newAd = ad.clone();
    newAd[field] = e.target.value;
    onChangeAd(newAd);
  };

  // const handleInputErrorVisibility = (e) => {
  //   if (+e.target.value < 500) {
  //     setError(true);
  //   } else {
  //     setError(false);
  //   }
  // };

  const handleInputErrorVisibility = (value) => {
    if (+value < 500) {
      setError(true);
      handleValidFromAdSettings(false);
    } else {
      setError(false);
      handleValidFromAdSettings(true);
    }
  };

  const handleChangeNum = (e, field) => {
    const newAd = ad.clone();
    newAd[field] = e.target.value.replace(/[A-Za-z._^%$#,!~@-]+/g, '');
    handleInputErrorVisibility(newAd[field]);
    onChangeAd(newAd);
  };

  const toLocaleStr = (value) => value.toLocaleString();

  const renderSettingForm = useMemo(() => (
    <>
      <div
        style={{
          flex: 3,
          marginRight: 18,
        }}
      >
        <div
          style={{
            marginBottom: 10,
          }}
          className={Styles.titleText}
        >
          廣告名稱
        </div>
        <TextInput
          onChange={(e) => handleChangeField(e, 'name')}
          value={ad.name}
        />
      </div>
      <div
        style={{
          flex: 2,
          marginRight: '18px',
        }}
      >
        <div className={Styles.titleContainer}>
          <div className={Styles.titleText}>日預算</div>
          <div>
            <ErrorIconPopover>
              <div className={classNames(Styles.popoverText, Styles.popoverContainer)}>
                日預算為初始設定，廣告花費將依照加總後的每日預算，依照結果自動優化分配
              </div>
            </ErrorIconPopover>
          </div>
        </div>
        <InputWrapper>
          <TextInput
            onChange={(e) => handleChangeNum(e, 'dayBudget')}
            value={toLocaleStr(+ad.dayBudget)}
            style={error ? { border: '2px solid #E4887D', borderRadius: '4px' } : { border: 'none', borderRadius: '0' }}
          />
          <InputErrorMessage visible={error} />
        </InputWrapper>
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <div className={Styles.titleText}>
          每月預算
        </div>
        <div
          style={{
            flex: 2,
          }}
          className={Styles.numberText}
        >
          $
          {(30 * ad.dayBudget).toLocaleString()}
        </div>
      </div>
    </>
  ), [ad]);

  const renderResult = useMemo(() => (
    <>
      <div className={Styles.resultBlock}>
        <div className={Styles.resultTitle}>廣告名稱:</div>
        <div className={Styles.resultContentText}>{ad.name}</div>
      </div>
      <div className={Styles.resultBlock}>
        <div className={Styles.resultTitle}>廣告預算:</div>
        <div className={Styles.resultNumberText}>{`$${30 * ad.dayBudget}`}</div>
      </div>
      <div className={Styles.resultBlock}>
        <div className={Styles.resultTitle}>日預算:</div>
        <div className={Styles.resultNumberText}>
          $
          {ad.dayBudget}
        </div>
      </div>
    </>
  ));

  return (
    <div className={Styles.container}>
      <div className={classNames(Styles.topTitleText, { [Styles.topTitleTextInactive]: !active })}>
        廣告設定
      </div>
      {disabled && <EmptyBar />}
      {(active || (!disabled && !active)) && (
        <ClickableDiv
          className={classNames(
            Styles.innerWrapperResult,
            { [Styles.innerWrapperSetting]: active },
          )}
          onClick={active ? () => {} : onSetActive}
        >
          {active && renderSettingForm}
          {!disabled && !active && renderResult}
        </ClickableDiv>
      )}
    </div>
  );
}

AdCardSetting.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  onSetActive: PropTypes.func,
  handleValidFromAdSettings: PropTypes.func,
};

AdCardSetting.defaultProps = {
  ad: new Ad(),
  onChangeAd: () => {},
  disabled: true,
  active: false,
  onSetActive: () => {},
  handleValidFromAdSettings: () => {},
};
